/**
 * metadata.ts
 * ----------------
 * Reducers for metadata across all portals.
 */

import { Map, Record } from 'immutable';

import { Action, PayloadAction } from '../../actions/types';
import { PreloadServices } from '../../constants/actions';
import { PreloadServicesPayload } from '../../models/payloads/preload';
import { Service } from '../../models/service';

interface MetadataStateFields {
    services: Map<string, Service>;
}

/**
 * Application state used by applications for prepopulated state.
 */
export class MetadataState extends Record<MetadataStateFields>({
    services: Map<string, Service>(),
}) {}

const initialState = new MetadataState();

const preloadServicesReducer = (state: MetadataState, action: PayloadAction<PreloadServicesPayload>) =>
    state.set('services', Map(action.payload));

/**
 * Reducer that updates parts of the application state related to static metadata, such as service information.
 * @param state Current application state.
 * @param action Action to be performed on state.
 * @returns Updated application state.
 */
export function metadataReducer (state: MetadataState = initialState, action?: Action) {
    // Pass back input state if no action given
    if (action === undefined) {
        return state;
    }

    switch (action.type) {
        case PreloadServices:
            return preloadServicesReducer(state, action as PayloadAction<PreloadServicesPayload>);

        default:
            return state;
    }
}
